"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const User_1 = require("../../models/User");
class UserSerializer {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    modelToPayload(payload) {
        return {
            'l': payload.login,
            'pk': payload.publicKey
        };
    }
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    fromPayloadToModel(data) {
        return new User_1.User(data['l'], data['pk']);
    }
}
exports.UserSerializer = UserSerializer;
